export const SHOW_PANEL = 'SHOW_PANEL'
export const HIDE_PANEL = 'HIDE_PANEL'
export const TOGGLE_OTHER_SITES = 'TOGGLE_OTHER_SITES'
export const ACTION_TOGGLE_OTHER_SITES = 'ACTION_TOGGLE_OTHER_SITES'

export const footer = {
  state: {
    panel: null,
    otherSites: false,
  },
  mutations: {
    [SHOW_PANEL]: function (state, panel) {
      state.panel = panel
    },
    [HIDE_PANEL]: function (state) {
      state.panel = null
    },
    [TOGGLE_OTHER_SITES]: function (state) {
      state.otherSites = !state.otherSites
    },
  },
  getters: {
    displayOtherSites: (state) => state.otherSites,
  },
  actions: {
    [ACTION_TOGGLE_OTHER_SITES]: function ({ commit }) {
      commit(TOGGLE_OTHER_SITES)
    },
  },
}
